// Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 5975, offsets 509429:509873. Structure and names inferred from code, not screenshots.

import * as LocalizedPathsModule from "../routing/localizedPaths.js";
const getLanguage = () => {
  if ("u" > typeof window) {
    let e = (0, LocalizedPathsModule.EH)(window.location.pathname);
    if (e) return e;
    let t = ((e) => {
      if ("zh" === e || "en" === e) return e;
      if (!e) return null;
      try {
        let t = JSON.parse(e);
        if (
          t &&
          "object" == typeof t &&
          "value" in t &&
          (!t.expired || t.expired > Date.now()) &&
          ("zh" === t.value || "en" === t.value)
        )
          return t.value;
      } catch {}
      return null;
    })(localStorage.getItem("user_language_preference"));
    if (t) return t;
  }
  return "zh";
};
export { getLanguage };
